import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
const features = ['5 módulos completos de video', '+20 lecciones en video', 'Actualizaciones de por vida', 'Garantía de 7 días'];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-gray-50 py-20 sm:py-28" data-id="element-118">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-119">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-120">
          {/* Section header */}
          <motion.div variants={itemVariants} className="mb-12 text-center" data-id="element-121">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-electric-blue/10 to-bright-orange/10 px-4 py-2 text-sm font-semibold text-electric-blue" data-id="element-122">
              <SparklesIcon className="h-4 w-4" data-id="element-123" />
              Oferta especial
            </span>
            <h2 className="font-heading text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-124">
              Invierte en Tu Futuro
            </h2>
          </motion.div>

          {/* Pricing card */}
          <motion.div variants={itemVariants} className="overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-125">
            {/* Discount banner */}
            <div className="bg-gradient-to-r from-electric-blue to-bright-orange px-6 py-3 text-center" data-id="element-126">
              <span className="font-heading text-lg font-bold text-white" data-id="element-127">
                🔥 92% de descuento — Oferta por tiempo limitado
              </span>
            </div>

            <div className="p-8 sm:p-12" data-id="element-128">
              {/* Price */}
              <div className="mb-8 text-center" data-id="element-129">
                <div className="mb-2 flex items-center justify-center gap-3" data-id="element-130">
                  <span className="text-2xl text-gray-400 line-through" data-id="element-131">
                    $97.00
                  </span>
                  <span className="rounded-full bg-green-100 px-3 py-1 text-sm font-semibold text-green-700" data-id="element-132">
                    Ahorras $89.50
                  </span>
                </div>
                <div className="flex items-baseline justify-center" data-id="element-133">
                  <span className="font-heading text-6xl font-extrabold text-gray-900 sm:text-7xl" data-id="element-134">
                    $7
                  </span>
                  <span className="font-heading text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-135">
                    .50
                  </span>
                </div>
                <p className="mt-2 text-gray-600" data-id="element-136">
                  Pago único — Acceso de por vida
                </p>
              </div>

              {/* Features list */}
              <div className="mb-10 grid gap-3 sm:grid-cols-2" data-id="element-137">
                {features.map((feature, index) => <div key={index} className="flex items-center gap-3" data-id="element-138">
                    <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-green-100" data-id="element-139">
                      <CheckIcon className="h-4 w-4 text-green-600" data-id="element-140" />
                    </div>
                    <span className="text-gray-700" data-id="element-141">{feature}</span>
                  </div>)}
              </div>

              {/* CTA Button */}
              <div className="text-center" data-id="element-142">
                <a href="https://pay.hotmart.com/K101706856C?checkoutMode=10&bid=1772484210715" target="_blank" rel="noopener noreferrer" data-id="element-143">
                  <button className="group inline-flex items-center gap-2 rounded-2xl bg-gradient-to-r from-electric-blue to-bright-orange px-10 py-4 text-lg font-bold text-white shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl" data-id="element-144">
                    <ZapIcon className="h-6 w-6" data-id="element-145" />
                    Inscríbete Ahora
                  </button>
                </a>
                <p className="mt-4 text-sm text-gray-500" data-id="element-146">
                  ⚡ Acceso inmediato después del pago
                </p>
              </div>
            </div>
          </motion.div>

          {/* Trust badges */}
          <motion.div variants={itemVariants} className="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500" data-id="element-147">
            <span className="flex items-center gap-2" data-id="element-148">🔒 Pago 100% seguro</span>
            <span className="flex items-center gap-2" data-id="element-149">
              💳 Todas las tarjetas
            </span>
            <span className="flex items-center gap-2" data-id="element-150">
              🌎 Disponible mundial
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}